import moment from 'moment';
import React, {Component, Fragment} from 'react';
import {FormGroup, Input, Label} from 'reactstrap';

class DatetimeResponse extends Component {
  // ----------------------
  // Lifecycle
  // ----------------------

  componentWillMount() {
    const valueObject = {
      datetime: new Date(this.props.value.datetime),
      isValid: true,
    };
    if (this.props.value.isScheduled) {
      valueObject.isScheduled = true;
    }
    // Validate for case of edit
    this.props.onValueChange(this.props.name, valueObject);
  }

  // ----------------------
  // Computed
  // ----------------------

  get date() {
    return new Date(this.props.value.datetime).getDate();
  }

  get daysInMonth() {
    const daysInMonth = moment(
      `${this.year}-${this.month + 1}`,
      'YYYY-MM',
    ).daysInMonth();
    const zeroIndexed = Array.from(Array(daysInMonth).keys());
    return zeroIndexed.map(index => index + 1);
  }

  get isDisabled() {
    return this.props.value.isScheduled;
  }

  get month() {
    return new Date(this.props.value.datetime).getMonth();
  }

  get year() {
    return new Date(this.props.value.datetime).getFullYear();
  }

  // ----------------------
  // Methods
  // ----------------------

  handleInput(name, value) {
    const year = name === 'year' ? parseInt(value, 10) : this.year;
    const month = name === 'month' ? parseInt(value, 10) : this.month;
    const date = name === 'date' ? parseInt(value, 10) : this.date;
    this.props.onValueChange(this.props.name, {
      datetime: new Date(year, month, date).toISOString(),
      isValid: true,
    });
  }

  // ----------------------
  // Render
  // ----------------------

  render() {
    return (
      <Fragment>
        {this.isDisabled ? (
          <div className="form-header">
            <legend>{this.props.prompt}</legend>
            <i className="fa fa-calendar" />&nbsp;
            <b>
              {this.month + 1}/{this.date}/{this.year}
            </b>
          </div>
        ) : (
          <div>
            <div className="form-header">
              <legend>{this.props.prompt}</legend>
            </div>
            <div>
              <FormGroup>
                <Label for="month">Month</Label>
                <Input
                  disabled={this.isDisabled}
                  name="month"
                  onChange={event =>
                    this.handleInput(event.target.name, event.target.value)
                  }
                  type="select"
                  value={this.month}
                >
                  {moment.months().map((month, index) => (
                    <option key={index.toString()} value={index}>
                      {month}
                    </option>
                  ))}
                </Input>
              </FormGroup>
              <FormGroup>
                <Label for="date">Date</Label>
                <Input
                  disabled={this.isDisabled}
                  name="date"
                  onChange={event =>
                    this.handleInput(event.target.name, event.target.value)
                  }
                  type="select"
                  value={this.date}
                >
                  {this.daysInMonth.map((day, index) => (
                    <option key={index.toString()} value={index + 1}>
                      {day}
                    </option>
                  ))}
                </Input>
              </FormGroup>
              <FormGroup>
                <Label for="year">Year</Label>
                <Input
                  disabled={this.isDisabled}
                  name="year"
                  onChange={event =>
                    this.handleInput(event.target.name, event.target.value)
                  }
                  type="select"
                  value={this.year}
                >
                  <option value={2018}>2018</option>
                  <option value={2019}>2019</option>
                  <option value={2020}>2020</option>
                  <option value={2021}>2021</option>
                  <option value={2022}>2022</option>
                  <option value={2023}>2023</option>
                  <option value={2024}>2024</option>
                  <option value={2025}>2025</option>
                  <option value={2026}>2026</option>
                  <option value={2027}>2027</option>
                </Input>
              </FormGroup>
            </div>
          </div>
        )}
      </Fragment>
    );
  }
}

export default DatetimeResponse;
